module.exports = __webpack_public_path__ + "static/media/floating_heart_red87c84d5a5bb429ffdc4d86685cb6efe9.gif";